// Which channel produced an order's `confirmed`. Written alongside every
// delivery_time_confirmed: 'confirmed' so the pill can say "Manually Confirmed"
// without giving manual confirms their own status value — the ~14
// `=== 'confirmed'` route-activation gates would not recognize one.
// Mirrors CONFIRMATION_SOURCE in onward-functions src/lib/twilio/confirmationOutcomes.js.
export const CONFIRMATION_SOURCE = {
    ROBOCALL: 'robocall',
    SMS: 'sms',
    MANUAL: 'manual',
    AUTO: 'auto',
    CUSTOMER: 'customer',
};
